import { Outlet } from 'react-router-dom';
import { LayoutBase } from '@/shared/ui/Layouts';

export const MainLayout = () => {
    return (
        <LayoutBase //
            pageSlot={<Outlet />}
        />
    );
};
